import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Output,
} from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { TYC_AGREEMENT_KEY } from '../../../../helpers/constants';
import { animate, style, transition, trigger } from '@angular/animations';
import { LucideAngularModule, Check, Circle } from 'lucide-angular';

@Component({
  selector: 'app-agreement-btn',
  standalone: true,
  imports: [ButtonModule, CommonModule, LucideAngularModule],
  templateUrl: './agreement-btn.component.html',
  styleUrl: './agreement-btn.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('iconAnimation', [
      transition('circle => check', [
        style({ opacity: 0, transform: 'scale(0.5)' }),
        animate(
          '200ms ease-out',
          style({
            opacity: 1,
            transform: 'scale(1)',
          })
        ),
      ]),
      transition('check => circle', [
        style({ opacity: 0, transform: 'scale(0.5)' }),
        animate(
          '200ms ease-out',
          style({
            opacity: 1,
            transform: 'scale(1)',
          })
        ),
      ]),
    ]),
    trigger('containerAnimation', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(-20px)' }),
        animate(
          '300ms ease-out',
          style({
            opacity: 1,
            transform: 'translateY(0)',
          })
        ),
      ]),
    ]),
  ],
})
export class AgreementBtnComponent {
  readonly check = Check;
  readonly circle = Circle;

  circleSize: number = 36;
  checkSize: number = 36;

  @Output() checkedChange = new EventEmitter<boolean>();
  isChecked: boolean = false;

  handleToggleChange() {
    this.isChecked = !this.isChecked;
    if (this.isChecked) {
      this.handleToggleOn();
      return;
    }
    this.handleToggleOff();
  }

  handleToggleOn() {
    localStorage.setItem(TYC_AGREEMENT_KEY, JSON.stringify(true));
    this.checkedChange.emit(this.isChecked);
  }

  handleToggleOff() {
    localStorage.setItem(TYC_AGREEMENT_KEY, JSON.stringify(false));
    this.checkedChange.emit(this.isChecked);
  }
}
